import { NotificationItem } from 'src/services/http/notifications';
import { LearningProgressStatus } from 'src/services/http/progress';

export enum GeneratePdfContentType {
  LEARNING_PATH = 'LEARNING_PATH',
  COURSE = 'COURSE',
  ARCHIVED_CONTENT = 'ARCHIVED_CONTENT',
  LIVE_TRAINING = 'LIVE_TRAINING',
}

export interface MyLearningLoaderProps {
  myLearningResourceData: MyLearningResourceData | null;
  recentlyViewedLessonsResources: RecentlyViewedLessonResource[] | null;
  archivedContentResources: ArchivedContentResource[] | null;
  areUnseenNotificationsAvailable?: boolean;
}

export interface MyLearningResourceData {
  learningPaths: MyLearningResource[] | null;
  courses: MyLearningResource[] | null;
}

export interface MyLearningResource {
  completedDate?: string;
  startedDate?: string;
  contentfulId: string;
  progressTotal: number;
  subCollectionTotal: number;
  slug?: string;
  title: string;
  badgeUrl?: string;
  learningPathSlug?: string;
  learningPathContentfulId: string | null;
  product?: string;
  products?: string;
  productsList?: string[]; // Array of products for filtering (even when display shows "Multiple products")
  historicalNotifications: NotificationItem[];
  unseenNotifications: NotificationItem[];
  status?: LearningProgressStatus;
  isSaved?: boolean;
}

export interface RecentlyViewedLessonResource {
  contentfulId: string;
  lastVisitedDate: Date;
  progressTotal: number;
  subCollectionTotal: number;
  slug: string;
  title: string;
  courseSlug?: string;
  learningPathSlug?: string;
  duration: number;
  product: string;
  productsList?: string[]; // Array of products for filtering
  status: LearningProgressStatus;
}

export interface ArchivedContentResource {
  entryTitle: string;
  completionDate: Date;
}
